
























import { Money } from 'v-money';

export default {
	name: 'MoneyInput',
	components: { Money },
	setup() {
		const money = ref({ precision: 0, prefix: 'R', decimal: ',', masked: false });
		return { money };
	},

	data() {
		return {
			amount: this.value || 0,
		};
	},

	watch: {
		amount() {
			this.$emit('input', this.amount);
		},
		value() {
			this.amount = this.value;
		},
	},

	props: {
		label: {
			required: true,
			type: String,
		},
		value: {
			required: false,
			type: [String, Number],
		},
		placeholder: {
			required: false,
			type: String,
		},
		error: {
			default: '',
			required: false,
			type: String,
		},
		disabled: {
			required: false,
			type: Boolean,
		},
		readonly: {
			default: false,
			required: false,
			type: Boolean,
		},
	},
};
